// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* -----------------modal---------------- */

.OrdersModal_boxModal__BLDp0 {
  transition: 0.3s;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  overflow-y: scroll;
  max-height: 90%;
  border-radius: 10px;
  box-shadow: 0 5px 50px -3px rgba(0, 0, 0, 0.511);
  font-size: 16px;
}

.OrdersModal_boxModal__BLDp0 .OrdersModal_exit__Sdtv3 {
  width: 90%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 10%;
  margin-top: 20px;
}

.OrdersModal_boxModal__BLDp0 .OrdersModal_exit__Sdtv3 .OrdersModal_exitIcon__2-iMc {
  transition: 0.3s;
}

.OrdersModal_boxModal__BLDp0 .OrdersModal_exit__Sdtv3 .OrdersModal_exitIcon__2-iMc:hover {
  transition: 0.2s;
  scale: 1.3;
  cursor: pointer;
  filter: brightness(1.6);
}

.OrdersModal_boxModal__BLDp0 .OrdersModal_titleModal__izmfj {
  width: 95%;
  display: flex;
  flex-direction: column;
  justify-items: center;
  align-items: flex-start;
}

.OrdersModal_boxModal__BLDp0 .OrdersModal_titleModal__izmfj p {
  font-size: 1.2rem;
  margin: 0;
}

.OrdersModal_boxModal__BLDp0 .OrdersModal_titleModal__izmfj span {
  font-size: 1rem;
  color: #5a5a5a;
  margin: 5px 0 0;
}

.OrdersModal_boxModal__BLDp0 .OrdersModal_filters__8rWke {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
}

@media screen and (max-width: 900px) {
  .OrdersModal_boxModal__BLDp0 {
    background-color: rgba(238, 238, 238, 0.95);
    transition: 0.3s;
    min-height: 100%;
    border-radius: 0;
    box-shadow: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Pages/Premios/ModalProviders/OrdersModal.module.css"],"names":[],"mappings":"AAAA,2CAA2C;;AAE3C;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,gDAAgD;EAChD,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE;IACE,2CAA2C;IAC3C,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;EAClB;AACF","sourcesContent":["/* -----------------modal---------------- */\n\n.boxModal {\n  transition: 0.3s;\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  overflow-y: scroll;\n  max-height: 90%;\n  border-radius: 10px;\n  box-shadow: 0 5px 50px -3px rgba(0, 0, 0, 0.511);\n  font-size: 16px;\n}\n\n.boxModal .exit {\n  width: 90%;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  height: 10%;\n  margin-top: 20px;\n}\n\n.boxModal .exit .exitIcon {\n  transition: 0.3s;\n}\n\n.boxModal .exit .exitIcon:hover {\n  transition: 0.2s;\n  scale: 1.3;\n  cursor: pointer;\n  filter: brightness(1.6);\n}\n\n.boxModal .titleModal {\n  width: 95%;\n  display: flex;\n  flex-direction: column;\n  justify-items: center;\n  align-items: flex-start;\n}\n\n.boxModal .titleModal p {\n  font-size: 1.2rem;\n  margin: 0;\n}\n\n.boxModal .titleModal span {\n  font-size: 1rem;\n  color: #5a5a5a;\n  margin: 5px 0 0;\n}\n\n.boxModal .filters {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-top: 20px;\n}\n\n@media screen and (max-width: 900px) {\n  .boxModal {\n    background-color: rgba(238, 238, 238, 0.95);\n    transition: 0.3s;\n    min-height: 100%;\n    border-radius: 0;\n    box-shadow: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"boxModal": `OrdersModal_boxModal__BLDp0`,
	"exit": `OrdersModal_exit__Sdtv3`,
	"exitIcon": `OrdersModal_exitIcon__2-iMc`,
	"titleModal": `OrdersModal_titleModal__izmfj`,
	"filters": `OrdersModal_filters__8rWke`
};
export default ___CSS_LOADER_EXPORT___;
